import { Link } from 'react-router-dom';
import { usePublicCmsContent } from '@/hooks/usePublicCmsContent';
import { CmsContent } from '@/components/CmsContent';
import { Spinner } from '@/components/ui/spinner';

export default function PrivacyPage() {
  const { data, isLoading, isError } = usePublicCmsContent('privacy-policy');

  return (
    <div>
      <section style={{
        background: 'linear-gradient(135deg, var(--navy) 0%, #2a3f6e 100%)',
        padding: '80px 0',
        color: 'white',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ fontSize: 48, marginBottom: 16 }}>
            {!isLoading && data?.data?.title ? data.data.title : 'Privacy Policy'}
          </h1>
          <p style={{ fontSize: 16, opacity: 0.7 }}>
            Last updated:{' '}
            {data?.data?.updated_at
              ? new Date(data.data.updated_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
              : 'February 1, 2026'}
          </p>
        </div>
      </section>

      <section style={{ padding: '80px 0' }}>
        <div className="container" style={{ maxWidth: 800 }}>
          {isLoading && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '80px 0' }}>
              <Spinner className="size-8" />
            </div>
          )}

          {isError && (
            <div style={{
              textAlign: 'center',
              padding: '80px 0',
              color: 'var(--gray-500)',
              fontSize: 16,
              lineHeight: 1.7,
            }}>
              This page's content is being updated. Please check back soon.
            </div>
          )}

          {!isLoading && !isError && data?.data && (
            <CmsContent html={data.data.content} />
          )}

          {!isLoading && (
            <div style={{ borderTop: '1px solid var(--gray-200)', paddingTop: 32, marginTop: 48, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
              <Link to="/terms" style={{ fontSize: 15, color: 'var(--sky)', fontWeight: 600 }}>View Terms of Service →</Link>
              <Link to="/contact" style={{ fontSize: 15, color: 'var(--sky)', fontWeight: 600 }}>Contact Us →</Link>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
